import { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DGGame } from '../../../../Models/App/Game/DGGame';
import GameSelector from '../../../../Services/Redux/Game/GameSelector';
import ThemeGameAction from '../../../../Services/Redux/ThemeGame/ThemeGameAction';
import { Nullable } from '../../../../Utils/Types/Nullable';
import { Optional } from '../../../../Utils/Types/Optional';
import { Game } from '../../Components/Game/Game';
import { PageLayout } from '../../Components/Layouts/PageLayout/PageLayout';
import { LoadingIndicator } from '../../Components/LoadingIndicator/LoadingIndicator';
import { Case } from '../../Components/Switch/Case';
import { Switch } from '../../Components/Switch/Switch';

export const ThemeGamePage: FunctionComponent = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state: string = useSelector(GameSelector.state);
  const game: Optional<DGGame> = useSelector(GameSelector.game);
  const hasWon: boolean = useSelector(GameSelector.hasWon);

  useEffect(() => {
    const gameId: Nullable<string> = searchParams.get('id');
    if (gameId) {
      dispatch(ThemeGameAction.fetchThemeGame(gameId));
    } else {
      dispatch(ThemeGameAction.fetchThemeGame());
    }
  }, [searchParams]);

  useEffect(() => {
    const gameId: Nullable<string> = searchParams.get('id');
    // Only redirect to win if we have won AND either we're loading the current theme game
    // (no gameId) or the loaded game matches the gameId from URL
    if (hasWon && (!gameId || game?.id === gameId)) {
      navigate('/theme/win', { replace: true });
    }
  }, [hasWon, game, searchParams]);

  return (
    <PageLayout>
      <Switch value={state}>
        <Case value="loading">
          <LoadingIndicator />
        </Case>
        <Case value="data">
          <Game game={game!} />
        </Case>
        <Case value="error">
          <div>Failed to load theme game</div>
        </Case>
      </Switch>
    </PageLayout>
  );
};
